module.exports = __webpack_public_path__ + "media/header-mobile-he.e405e5f0.mp4";